module.exports = __webpack_public_path__ + "static/media/plan.337a90dc.png";